var formMessageStyle = {
    outerContainer: {
        default: {
            fontFamily: "'Rubik', 'Helvetica', 'Arial'",
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: 'normal',
            lineHeight: '1.25',
            textIndent: 0,
            textShadow: 'none',
            textTransform: 'none',
            display: 'block',
            fontSize: '0.75rem',
            margin: '0.25rem 0 0',
            padding: 0,
            verticalAlign: 'top'
        },
        messageType: {
            info: {
                color: 'rgb(105,113,122)'
            },
            error: {
                color: 'rgb(219,44,0)'
            }
        },
        textDirection: {
            ltr: {
                textAlign: 'left',
                direction: 'ltr'
            },
            rtl: {
                textAlign: 'right',
                direction: 'rtl'
            }
        }
    },
    errorIconContainer: {
        default: {
            verticalAlign: 'middle',
            position: 'relative',
            top: '2px'
        },
        textDirection: {
            ltr: {
                paddingRight: '5px'
            },
            rtl: {
                paddingLeft: '5px'
            }
        }
    }
};
export default formMessageStyle;
